import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CircularProgress, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useAuth } from 'src/app/infra/auth';
import { useRoute } from 'src/app/infra/routes';
import { postUploadFile } from 'src/app/services/cadastro';
import { postProcuracoes } from 'src/app/services/votacao';
import { BtnLoading, Msgbox } from 'src/app/shared/utils';
import { Token } from 'src/app/types/accounts';
import { CodTipoArquivo } from 'src/app/types/votacao';
import { useWrapper } from 'src/utils/axios';
import { Form, Title, Wrapper } from '../login';

const Centered = styled.span`
  display: flex;
  justify-content: center;
  width: 100%;
  font-weight: bold;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;

  h5,
  .MuiFormControl-root {
    width: 100%;
    margin-top: 0px;
  }
`;

interface Props {
  open: boolean;
  handleClose: (done: boolean) => void;
  codigoVotacao: Number | undefined;
  data: Token | undefined;
  urlModeloProcuracao: string | undefined;
  identidadeVisual: object;
}

export default ({
  open,
  handleClose,
  codigoVotacao,
  data,
  urlModeloProcuracao,
  identidadeVisual
}: Props) => {
  const {
    params: { condominio }
  } = useRoute();
  const sendProcuracoes = useWrapper();
  const uploadFile = useWrapper();
  const { authOff } = useAuth();

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [unidade, setUnidade] = useState(['']);
  const [url, setUrl] = useState('');
  const [pdfName, setPdfName] = useState('');
  const [errorUpload, setErrorUpload] = useState('');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [listaUnidades, setListaUnidade] = useState(['']);

  const cleanFields = () => {
    setNome('');
    setEmail('');
    setCpfCnpj('');
    setUnidade(['']);
    setUrl('');
    setPdfName('');
    uploadFile.reset();
  };

  const unidadeChange = (e) => {
    setUnidade(e.target.value);
  };

  const selecionar = (e) => {
    return e?.join(', ');
  };

  const enviarProcuracao = () => {
    sendProcuracoes.exec(
      postProcuracoes({
        votacao: Number(codigoVotacao),
        condominio: Number(condominio),
        unidades: unidade.filter((t) => t !== ''),
        nomeProcuracao: nome,
        emailProcuracao: email,
        cpfCnpjProcuracao: cpfCnpj,
        urlArquivoProcuracao: url
      }),
      () => setOpenConfirm(true)
    );

    return () => sendProcuracoes.cancel();
  };

  const hasBtnModelo = React.useMemo(() => {
    switch (condominio) {
      case '2202':
        return false;
      default:
        return true;
    }
  }, [condominio]);

  useEffect(() => {
    if (open) {
      if (
        data?.unidadeLogin?.tipoUsuario === 1 &&
        data.unidadeLogin.situacao === 2
      ) {
        setListaUnidade(Array(String(data?.unidadeLogin?.unidade)));
        if (data?.outrasUnidadesCpfCnpj?.length) {
          const outrasUnidades: string[] = [];
          data.outrasUnidadesCpfCnpj?.forEach((t) => {
            if (t.tipoUsuario === 1 && t.situacao === 2) {
              outrasUnidades.push(t.unidade);
            }
          });
          setListaUnidade(
            Array(String(data?.unidadeLogin?.unidade)).concat(outrasUnidades)
          );
        }
      }
      cleanFields();
    }
  }, [open]);

  const generateUrl = (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    uploadFile.exec(
      postUploadFile({
        arquivos: [file],
        codTipoArquivo: CodTipoArquivo.AnexosProcuracao
      }),
      (res) => {
        if (res) {
          setUrl(String(res));
          setPdfName(file?.name || '');
        }
      },
      (err) => {
        const match = /HubertCustomException:(.*?)\s+at/gi.exec(
          err?.['data'] || ''
        );
        setErrorUpload(match?.[1]?.trim() || err?.['data']);
      }
    );
  };

  const close = () => {
    authOff();
    handleClose(true);
  };

  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <Row>
        <Title
          variant="h5"
          color="primary"
          style={{ color: identidadeVisual['fontColor'] }}
        >
          Enviar Procuração
        </Title>
        <IconButton onClick={() => handleClose(false)}>
          <Close />
        </IconButton>
      </Row>
      <DialogContent>
        <Wrapper>
          <Centered>
            Preencha com os dados do Procurador e selecione para quais unidades
            a procuração será válida.
          </Centered>
          <Centered style={{ paddingTop: '6px' }}>
            IMPORTANTE: A procuração cadastrada será validada e a confirmação de
            aceite será enviada por email. Em caso de dúvidas converse com seu
            gerente
          </Centered>
          <Form style={{ marginTop: '0rem' }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="nome">Nome do Procurador</InputLabel>
              <OutlinedInput
                id="nome"
                label="Unidade"
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
              />
            </FormControl>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="email">Email do Procurador</InputLabel>
              <OutlinedInput
                id="email"
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="cpfCnpj">Cpf/Cnpj Procurador</InputLabel>
              <OutlinedInput
                id="cpfCnpj"
                label="Cpf/Cnpj"
                type="text"
                value={cpfCnpj}
                onChange={(e) => setCpfCnpj(e.target.value)}
              />
            </FormControl>
            <Row>
              <FormControl>
                <InputLabel id="unidade-label">
                  Quais unidades deseja enviar a Procuração?
                </InputLabel>
                <Select
                  labelId="unidade-label"
                  id="unidade"
                  multiple
                  value={unidade.filter((t) => t !== '')}
                  onChange={unidadeChange}
                  input={<Input />}
                  renderValue={selecionar}
                >
                  {listaUnidades?.map((unid) => (
                    <MenuItem key={unid} value={unid}>
                      <Checkbox
                        checked={unidade.indexOf(unid) > -1}
                        color="primary"
                        style={{
                          color: identidadeVisual['headerColor'] || '#083F8B'
                        }}
                      />
                      <ListItemText primary={unid} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Tooltip title="É permitido enviar 1 Procuração para várias unidades desde que seja em nome do mesmo Procurador.">
                <InfoIcon />
              </Tooltip>
            </Row>
            <Card>
              <CardContent>
                <Typography variant="h6">
                  Anexar Procuração (pdf):
                  <Button
                    style={{ marginLeft: '4px' }}
                    size="small"
                    variant="contained"
                    component="label"
                  >
                    {uploadFile.loading ? <CircularProgress /> : 'Clique aqui'}
                    <input
                      accept="application/pdf"
                      type="file"
                      onChange={generateUrl}
                      hidden
                    />
                  </Button>
                </Typography>
                {errorUpload ? (
                  <p style={{ color: 'red', fontSize: '14px' }}>
                    {errorUpload}
                  </p>
                ) : url ? (
                  <a
                    href={url}
                    target="_blank"
                    style={{ color: 'green', fontSize: '14px' }}
                  >
                    {pdfName}
                  </a>
                ) : (
                  <></>
                )}
                {hasBtnModelo && (
                  <a
                    style={{ color: '#000', textDecoration: 'underline' }}
                    href={urlModeloProcuracao}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Typography color="textSecondary">
                      Baixe aqui um modelo da procuração.
                    </Typography>
                  </a>
                )}
              </CardContent>
            </Card>
            <BtnLoading
              disabled={!nome || !cpfCnpj || !email || !unidade || !url}
              customColor
              backgroundColor={identidadeVisual?.['headerColor'] || '#083F8B'}
              loading={sendProcuracoes.loading}
              fullWidth
              onClick={enviarProcuracao}
              style={{ marginTop: '12px' }}
            >
              Enviar Procuração
            </BtnLoading>
            <Dialog
              open={openConfirm}
              onClose={() => setOpenConfirm(false)}
              maxWidth="xs"
            >
              <Title variant="h5" color="primary">
                Procuração Enviada com Sucesso
              </Title>
              <DialogContent>
                <Wrapper>
                  <Centered>
                    A confirmação de aprovação da Procuração será enviada para o
                    e-mail indicado. Se houver algum problema, também
                    informaremos por e-mail, para que seja corrigido.
                  </Centered>
                  <DialogActions
                    style={{ display: 'flex', justifyContent: 'center' }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={false}
                      onClick={() => {
                        cleanFields();
                        setOpenConfirm(false);
                      }}
                    >
                      Adicionar Nova
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={false}
                      onClick={() => close()}
                    >
                      Sair
                    </Button>
                  </DialogActions>
                  {/* <Centered>
                            <Typography color="textSecondary">
                                <Button size="small">Clique aqui para acessar e compartilhar o manual de uso da assembléia virtual.</Button>
                            </Typography>
                          </Centered> */}
                </Wrapper>
              </DialogContent>
            </Dialog>
          </Form>
        </Wrapper>
      </DialogContent>
      <Msgbox
        error={sendProcuracoes.error}
        onClose={() => sendProcuracoes.reset()}
      />
    </Dialog>
  );
};
